export const SLIDER_MARKS = [
  { value: 1, label: '1' },
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 20, label: '20' },
  { value: 40, label: '40' },
  { value: 60, label: '60' },
  { value: 80, label: '80' },
  { value: 100, label: '100' },
];

export const FONT_SIZES = [8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72] as const;

export const TEXT_ROTATION_MIN = 0;
export const TEXT_ROTATION_MAX = 360;

export const DEFAULT_TEXT_COLOR = '#221271';

export const COUNTRY_CODES = {
  LT: 'LT',
  LV: 'LV',
  EE: 'EE',
} as const;

export type CountryCode = keyof typeof COUNTRY_CODES;

export const DEBOUNCE_DELAY = 300;

export enum AddressBookType {
  All = 'all',
  External = 'external',
  Internal = 'inernal',
}
